import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  CalendarMonthOutlined as CalendarMonthOutlinedIcon,
  LabelOutlined as LabelOutlinedIcon,
  Person2Outlined as Person2OutlinedIcon,
  Tag as TagIcon,
} from '@mui/icons-material';
import { Typography } from '@mui/material';

import { ModalInfo, ModalSidebarContent } from '@/components/Modal';
import { NomenclatureStatusSelect } from '@/components/nomenclature/NomenclatureStatus/NomenclatureStatusSelect';
import { useProfile } from '@/modules/profile';
import type { RecordStatusId } from '@/shared/constants/record-status.constants.ts';
import { formatDateTime } from '@/shared/helpers/format.helpers';

import type { NomenclatureFormProps } from './NomenclatureForm';

export type NomenclatureModalInfoProps = {
  isEditMode: boolean;
  drug: NomenclatureFormProps['drug'];
};

export const NomenclatureModalInfo = (props: NomenclatureModalInfoProps) => {
  const { drug, isEditMode } = props;
  const { user } = useProfile();

  const { setValue } = useFormContext();

  const handleSelectStatus = (itemRecordStatusId: RecordStatusId) => {
    setValue('record_status_id', itemRecordStatusId, {
      shouldDirty: true,
    });
  };

  return (
    <Fragment>
      <ModalSidebarContent>
        <ModalInfo
          data={[
            ...(isEditMode
              ? [
                  {
                    icon: <TagIcon fontSize="small" />,
                    label: 'ID',
                    value: drug?.id,
                  },
                ]
              : []),
            {
              icon: <LabelOutlinedIcon fontSize="small" />,
              label: 'Статус',
              value: <NomenclatureStatusSelect onSelectStatus={handleSelectStatus} drug={drug} />,
            },
          ]}
        />
      </ModalSidebarContent>
      <ModalSidebarContent>
        <ModalInfo
          title="Создание"
          data={[
            {
              icon: <Person2OutlinedIcon fontSize="small" />,
              label: 'Автор',
              value: isEditMode ? drug?.author?.name || '' : user?.first_name,
            },
            {
              icon: <CalendarMonthOutlinedIcon fontSize="small" />,
              label: 'Дата создания',
              value: isEditMode
                ? (drug && formatDateTime(drug?.created_at, 'dd.MM.yyyy hh:mm:ss')) || ''
                : formatDateTime(new Date(), 'dd.MM.yyyy'),
            },
          ]}
        />
        {isEditMode && !!drug?.initiator?.id && (
          <ModalInfo
            title="Последнее изменение"
            data={[
              {
                icon: <CalendarMonthOutlinedIcon fontSize="small" />,
                label: 'Дата',
                value: (
                  <Fragment>
                    {formatDateTime(new Date(drug.updated_at), 'dd.MM.yyyy')}{' '}
                    <Typography component="span" variant="inherit" color="neutral.700">
                      {formatDateTime(new Date(drug.updated_at), 'HH:mm:ss')}
                    </Typography>
                  </Fragment>
                ),
              },
              {
                icon: <Person2OutlinedIcon fontSize="small" />,
                label: 'Инициатор',
                value: drug.initiator.name,
              },
            ]}
          />
        )}
      </ModalSidebarContent>
    </Fragment>
  );
};
